export default "__VITE_ASSET__3e090e39__"